import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Status',
      fields: {
        room_service_visible: {
          label: 'Værelses-/bordservice synlig',
        },
        has_room_service: {
          label: 'Værelses-/bordservice',
        },
      },
    },
    settings: {
      title: 'Indstillinger',
      table_number: {
        label: 'Vis bordnummer',
      },
    },
    locations: {
      title: 'Lokationer',
    },
  },
  form: {
    google_place: {
      label: 'Navn',
      placeholder: 'Navn på Google Maps',
    },
    type: {
      label: 'Type',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Værelsesservice',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Bordservice',
      },
    },
    name: {
      label: 'Lokationsnavn',
      placeholder: 'Indtast et lokationsnavn, der er tydeligt for kunden',
    },
    street_name: {
      label: 'Gade',
      placeholder: 'Gadenavn',
    },
    street_number: {
      label: 'Husnummer',
      placeholder: 'Husnummer',
    },
    city: {
      label: 'By',
      placeholder: 'By',
    },
    zip_code: {
      label: 'Postnummer',
      placeholder: 'Postnummer',
    },
  },
  fields: {
    id: 'id',
    type: 'Type',
    name: 'Navn',
    address: 'Adresse',
    is_active: 'Aktiv',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Værelsesservice',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Bordservice',
  },
  modals: {
    delete_location: {
      title: 'Er du sikker?',
      description: 'Dette sletter lokationen „{{name}}“',
    },
  },
  buttons: {
    save: 'Gem',
    delete: 'Slet',
  },
  toasts: {
    failed_to_load_locations: 'Lokationerne kunne ikke indlæses. Genindlæs siden',
    failed_to_create_location: 'Lokationen kunne ikke oprettes',
    failed_to_toggle_location: 'Lokationens tilgængelighed kunne ikke ændres',
    failed_to_delete_location: 'Lokationen kunne ikke slettes',
    location_got_created: 'Lokationen er oprettet',
    location_got_deleted: 'Lokationen er slettet',
    saving_success: 'Gemt',
    saving_error: 'Kunne ikke gemme',
  },
};
